var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import Icon from "../../Icon";
import { TileInvestWrapper, TileInvestIcon, TileInvestTitle, TileInvestArrow } from "./TileInvest.styled";

var TileInvest = function TileInvest(_a) {
  var title = _a.title,
      icon = _a.icon,
      url = _a.url,
      props = __rest(_a, ["title", "icon", "url"]);

  return React.createElement(TileInvestWrapper, __assign({
    to: url
  }, props), React.createElement(TileInvestIcon, null, React.createElement(Icon, {
    name: icon
  })), React.createElement(TileInvestTitle, {
    variant: "tile2"
  }, title), React.createElement(TileInvestArrow, null, React.createElement(Icon, {
    name: "ChevronRight",
    width: 42,
    height: 42,
    mb: "0.8rem"
  })));
};

export default TileInvest;